/* Manu AI v15 (22/10/2026) — « Refaire » demande d'abord ce qu'il faut changer, puis retouche le logo existant.
 * - Clic sur « Refaire » (face dessinée par Manu) : Manu demande « Qu'est-ce que tu veux changer ? » avec 4 raccourcis
 *   (autres couleurs, changer le texte, plus simple, tout refaire) ; une phrase libre fonctionne aussi.
 * - La retouche part au serveur avec le logo actuel (`base`) et la demande (`edit`) : le modèle ne change que ça
 *   (api/studio.js, action logo, fidélité haute). Les 2 premières retouches d'une session ne consomment pas de création.
 * - Faces importées par le client ou mode démo (sans serveur) : comportement d'origine (redessin).
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par v9 → v14, chargés avant. */
(function () {
  'use strict';

  var FREE_EDITS = 2;
  var TXT = {
    fr: { ask: 'Qu’est-ce que tu veux changer sur le {side} ? Dis-le-moi en une phrase, je ne touche qu’à ça.', colors: 'Autres couleurs', text: 'Changer le texte', simple: 'Plus simple', all: 'Tout refaire' },
    en: { ask: 'What do you want to change on the {side}? Tell me in one sentence, I will only touch that.', colors: 'Other colours', text: 'Change the text', simple: 'Simpler', all: 'Redo everything' },
    es: { ask: '¿Qué quieres cambiar de la cara «{side}»? Dímelo en una frase, solo tocaré eso.', colors: 'Otros colores', text: 'Cambiar el texto', simple: 'Más simple', all: 'Rehacer todo' },
    de: { ask: 'Was soll ich bei „{side}“ ändern? Sag es in einem Satz, ich ändere nur das.', colors: 'Andere Farben', text: 'Text ändern', simple: 'Einfacher', all: 'Alles neu' },
    it: { ask: 'Cosa vuoi cambiare sul lato «{side}»? Dimmelo in una frase, tocco solo quello.', colors: 'Altri colori', text: 'Cambia il testo', simple: 'Più semplice', all: 'Rifai tutto' }
  };
  // Consignes envoyées au modèle d'image (anglais, toujours)
  var EDIT = {
    colors: 'Change the colour palette to a different bold combination that stays readable on fabric. Keep the drawing, composition and lettering shapes identical.',
    simple: 'Simplify the design: fewer details and fewer colours. Keep the main subject and the lettering.',
    text: function (x) { return 'Replace the text with exactly: "' + x + '" (spelled exactly). Keep the same lettering style, colours and layout.'; }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v15) return;
    inst._v15 = true;
    inst.editPrompts = EDIT;
    inst.redoTx = function () { return TXT[inst.loc] || TXT.fr; };
    function tx() { return TXT[inst.loc] || TXT.fr; }

    /* ---------- « Refaire » : on demande d'abord ----------- */
    var baseRedo = inst.redoFace;
    inst.redoFace = function (side) {
      var self = this, s = this.s, f = s.faces[side];
      if (!(this.endpoint && f && f.src && !f.own && !f.mock)) return baseRedo.apply(this, arguments);
      var t = tx(), name = (this.t.sides[side] || side).toLowerCase();
      s.pending = 'redo-edit'; s.redoSide = side;
      this.user(String(this.t.redo_face || '').replace('{side}', name));
      this.lockThread(); this.resultEl = null;
      this.bot(esc(t.ask.replace('{side}', name))).then(function () {
        self.chips([
          { cmd: 'redo-hint', v: 'colors', l: t.colors },
          { cmd: 'redo-hint', v: 'text', l: t.text },
          { cmd: 'redo-hint', v: 'simple', l: t.simple },
          { cmd: 'redo-all', l: t.all, ghost: true }
        ]);
        if (window.matchMedia('(min-width: 750px)').matches && self.replyField) self.replyField.focus({ preventScroll: true });
      });
    };

    // Lance la retouche d'une face à partir de son logo actuel
    inst.applyEdit = function (side, text) {
      var s = this.s, f = s.faces[side];
      s.pending = null; this.quick.innerHTML = '';
      if (!f || !f.src) { this.generateFaces([side], true); return; }
      s.edit1 = { side: side, text: String(text).slice(0, 300), base: f.src };
      this.lockThread(); this.resultEl = null;
      this.generateFaces([side], true);
    };

    var baseFree = inst.freeText;
    inst.freeText = function (text) {
      var s = this.s;
      if ((s.pending === 'redo-edit' || s.pending === 'redo-text') && s.redoSide) {
        this.user(text);
        this.applyEdit(s.redoSide, s.pending === 'redo-text' ? EDIT.text(String(text).trim().slice(0, 40)) : String(text).trim());
        return;
      }
      return baseFree.apply(this, arguments);
    };

    var baseCommand = inst.command;
    inst.command = function (cmd, value, label) {
      var s = this.s;
      if (cmd === 'redo-hint') {
        this.user(label); this.quick.innerHTML = '';
        if (value === 'text') { s.pending = 'redo-text'; this.bot(esc(this.t.ask_new_text)); return; }
        this.applyEdit(s.redoSide, EDIT[value]);
        return;
      }
      if (cmd === 'redo-all') {
        this.user(label); this.quick.innerHTML = ''; s.pending = null;
        this.lockThread(); this.resultEl = null; this.generateFaces([s.redoSide], true);
        return;
      }
      return baseCommand.apply(this, arguments);
    };

    /* ---------- Appel serveur : logo actuel + demande ---------- */
    var baseApi = inst.apiLogo;
    inst.apiLogo = function (side, ref) {
      var s = this.s, e = s.edit1;
      if (!e || e.side !== side) return baseApi.apply(this, arguments);
      s.edit1 = null;
      var brief = { sport: s.sport, idea: s.idea, logo_text: s.noText ? null : s.logoText, style: s.style, goal: s.goal, place: side, front_desc: s.frontDesc, back_desc: s.backDesc, locale: this.loc, front_format: this.frontFormat(), zone: e.copy || !this.zoneFor ? undefined : this.zoneFor(side, true) };
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      if (ctrl) setTimeout(function () { ctrl.abort(); }, 110000);
      var free = !e.copy && (s.edits || 0) < FREE_EDITS; // v22 : une copie fidèle compte comme une création
      return fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'logo', side: side, brief: brief, base: e.base, edit: e.text, copy: e.copy ? true : undefined, rights: e.copy ? true : undefined }), signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) { var er = new Error(r.status); er.status = r.status; throw er; } return r.json(); })
        .then(function (j) {
          if (!j || !j.image_url) throw new Error('empty');
          if (!e.copy) s.edits = (s.edits || 0) + 1;
          // generateFaces compte une création à la fin : les 2 premières retouches sont offertes
          if (free) { try { sessionStorage.setItem('aisRuns', JSON.stringify(Math.max(0, (JSON.parse(sessionStorage.getItem('aisRuns')) || 0) - 1))); } catch (x) {} }
          return j.image_url;
        });
    };
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
